import { env } from "../../../config/env";
import { apiClient } from "../../config";

import {
  ContactMessagePayload,
  ContactMessageResponse,
} from "../../interface/public.interface";

class ContactService {
  /**
   * 📩 SEND CONTACT MESSAGE
   */
  async sendContactMessage(
    payload: ContactMessagePayload
  ): Promise<ContactMessageResponse> {
    try {
      const response = await apiClient.post<ContactMessageResponse>(
        env.PUBLIC_CONTACT_URL,
        payload
      );

      return response.data;
    } catch (error: any) {
      /**
       * ⚠️ Validation error
       */
      if (error.response?.status === 422) {
        throw {
          type: "validation",
          errors: error.response.data.errors,
        };
      }

      /**
       * ⚠️ Server error
       */
      throw {
        type: "server",
        message: "Une erreur est survenue",
      };
    }
  }
}

export const publicContactService = new ContactService();